module.exports = __webpack_public_path__ + "img/share-img03.51989056.png";